var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c(_vm.feesComponent,{tag:"component",attrs:{"transaction":_vm.transaction}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-margin"},[_c('h4',[_vm._v("Financial Breakdown For The Current Transaction (ZAR)")])])
}]

export { render, staticRenderFns }